<mat-card [ngClass]="{'desktop': isDesktop, 'mobile': !isDesktop}" class="account-mat-card" >
  <mat-card-content class="account-header">
    <mat-expansion-panel #expansionPanel [hideToggle]="isDesktop" [expanded]="isDesktop" [disabled]="isDesktop">
      <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
        <mat-panel-title>
          <div class="row">
            <div class="cell cell-title">
              <h1 class="header">{{'account.title' | translate}}</h1>
              <h3 class="data">{{account.accountNumber}}</h3>
            </div>
            <div class="cell cell-paymentMethod">
              <div class="row">
                <div>
                  <h4 class="header">{{'account.payment_method.title' | translate}}</h4>
                  <h3 class="data">{{account.paymentMethod}}</h3>
                </div>
                <div *ngIf="showUpdatePaymentMethod">
                  <a class="update-payment-method" mat-stroked-button href="{{ppUiHost}}/#/accounts/{{account.accountId}}/payment-method" target="_blank">{{'account.payment_method.change' | translate}}</a>
                </div>
              </div>
            </div>

          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="subscription-list">
        <pp-subscription [account]="account" *ngFor="let subscription of account.subscriptions" [subscription]="subscription"></pp-subscription>
      </div>
    </mat-expansion-panel>
  </mat-card-content>
</mat-card>
